import Checkbox from 'components/shared/Checkbox/Checkbox';

import { groupStatusContent } from '../../lib/constants';
import TableBodyHeader from '../TableBodyHeader';

const TableGfeDetails = ({
  visibleCols,
  statusGroup,
  onCheckedChange,
  isChecked,
  preview,
  variant
}) => {
  const handleCheckedChange = (e) => {
    const isCheckedValue = e.target.checked;
    onCheckedChange(statusGroup.statusName, isCheckedValue);
  };

  return (
    <TableBodyHeader
      variant={variant}
      actions={
        !preview && (
          <Checkbox
            isChecked={isChecked}
            onChange={handleCheckedChange}
            size={16}
            className="bg-white focus:bg-white"
          />
        )
      }
      columnDefs={visibleCols}
      value={groupStatusContent[statusGroup.statusName]?.value}
      description={groupStatusContent[statusGroup.statusName]?.description}
    />
  );
};

export default TableGfeDetails;
